import axios from "../../utils/axios";

// A function to Fetch Posts from the server
export async function saveBlogPost(id, payload) {
  const response = await axios.patch(`/blogs/${id}`, payload, {
    headers: { "Content-Type": "application/json" },
  });

  return response.data;
}
